import { Component } from 'react'
import { Provider, ReactReduxContext } from 'react-redux'

import { PersistGate } from 'redux-persist/integration/react'

import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { AdapterMoment } from '@mui/x-date-pickers-pro/AdapterMoment'
import { MuiThemeProvider, StylesProvider } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'

import { ConnectedRouter } from 'connected-react-router'

import { tabeebTheme, ToastsProvider } from '@collaborate-health/uikit'

import { HelmetProvider } from 'react-helmet-async'

import { store, persistor, history } from '@tabeeb/store'

import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { queryClient } from '@tabeeb/services/queryClient'
import { storagePersister } from '@tabeeb/services/storagePersister'
import { onAppMounted } from '../../state/actions/appActions'

import UI from './App'
import TenantThemeProvider from './TenantThemeProvider'
import SentryContextProvider from './SentryContextProvider'
import PageLayoutContextProvider from './PageLayoutContextProvider'

class App extends Component {
  componentDidMount() {
    store.dispatch(onAppMounted())
  }

  render() {
    return (
      <Provider store={store} context={ReactReduxContext}>
        <PersistGate persistor={persistor}>
          <StylesProvider injectFirst>
            <MuiThemeProvider theme={tabeebTheme}>
              <TenantThemeProvider>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <LocalizationProvider dateAdapter={AdapterMoment}>
                    <ConnectedRouter history={history} context={ReactReduxContext}>
                      <SentryContextProvider>
                        <HelmetProvider>
                          <ToastsProvider>
                            <PersistQueryClientProvider
                              client={queryClient}
                              persistOptions={{
                                persister: storagePersister,
                                dehydrateOptions: {
                                  shouldDehydrateQuery: (q) => q.meta?.persist === true,
                                },
                              }}
                            >
                              <PageLayoutContextProvider>
                                <UI />
                              </PageLayoutContextProvider>
                            </PersistQueryClientProvider>
                          </ToastsProvider>
                        </HelmetProvider>
                      </SentryContextProvider>
                    </ConnectedRouter>
                  </LocalizationProvider>
                </MuiPickersUtilsProvider>
              </TenantThemeProvider>
            </MuiThemeProvider>
          </StylesProvider>
        </PersistGate>
      </Provider>
    )
  }
}

export default App
